import { h,Component } from 'vue'
import {Filters,defaultFilters} from "@/types/Filters";
import {UserCircleIcon,FunnelIcon,UserIcon, PhotoIcon,VideoCameraIcon,HandThumbUpIcon,CalendarIcon,DocumentMagnifyingGlassIcon } from "@heroicons/vue/24/solid";       

type FilterOption = {
	type: "multiple" | "single" | "number" | "text";
	icon: Component;
	options: Record<string, string>;
	label: string;
	help?: string; // Make optional since not all filters have help text
};

type FilterInfo = {
	filetype: FilterOption;
	moderationStatus: FilterOption;
	status: FilterOption;
	uid: FilterOption;
	startTime: FilterOption;
	endTime: FilterOption;
	extension: FilterOption;
};


export const filterInfo : FilterInfo  = {
	filetype: {
		type:"multiple",
		icon:VideoCameraIcon,
		options: {
			"0": "Unknown",
			"1": "Image",
			"2": "Video",
			"3": "Audio",
			"4": "Other",
		},
		label: "File Types",
		help: "Select between images, video, audio and other types of files",
	},
	moderationStatus: {
		type:"single",
		icon:HandThumbUpIcon,
		options: {
			"0": "Unmoderated",
			"1": "Approved",
			"2": "Denied"
		},
		label: "Moderation Status",
		help: "Current moderation status of the media, eg. approved, denied",
	},
	status: {
		type:"multiple",
		icon:FunnelIcon,
		options: {
			"0": "Uploading",
			"1": "Queued",
			"2": "Processing",
			"3": "Ready",
			"4": "Failure",
			"5": "Upload Failure",
			"100": "Trashed",
			"200": "Deleted",
		},
		label: "File Status",
		help: "Status of the submission",
	},
	uid: {
		type: "number",
		label: "User Id",
		icon:UserCircleIcon,
		options:{},
	},
	startTime: {
		type:"single",
		label: "Start Date",
		icon:CalendarIcon,
		options:{ 
			"24 Hours ago":"Last 24 Hrs ",
			"14 Days ago":"Last 2 Weeks",
			"30 Days ago":"30 Days Ago",
			"60 Days ago":"60 Days Ago",
			"90 Days ago":"90 Days Ago",
			"365 Days ago":"1 Year Ago",
			"10 Years ago":"All Time"
		},
	},
	endTime: {
		label: "End Date",
		type: "single",
		icon:CalendarIcon,
		options: { 
			"Now":"Now",
			"24 Hours ago":"Last 24 Hrs ",
			"14 Days ago":"Last 2 Weeks",
			"30 Days ago":"30 Days Ago",
			"60 Days ago":"60 Days Ago",
			"90 Days ago":"90 Days Ago",
			"365 Days ago":"1 Year Ago",
			"10 Years ago":"All Time"
		}
	},
	extension: {
		label: "File Extension",
		type: "text",
		icon:DocumentMagnifyingGlassIcon,
		options: {
		}
	},
} as const;

export type FilterInfoKeys = keyof typeof filterInfo;


export const getPrettyValues = ( label: FilterInfoKeys, filters: Filters): number | number[] | string | string[] | null => {
	const info = filterInfo[label]; // Get filter info based on label
	const filterValue = filters[label as keyof Filters] ?? null; // Ensure filterValue exists or default to null
	const defaultValue = defaultFilters[label as keyof Filters] ?? null; // Ensure defaultValue exists or default to null

	if (info.type === 'single') {
		if (defaultValue && filterValue != defaultValue) {
			return info['label'] + ": "+info.options?.[filterValue as keyof typeof info.options] || filterValue; // Pretty value or raw value
		}
		return '';
	}
		else if (info.type === 'text') {
		if (filterValue!='') {
			return info['label'] + ": "+filterValue;
		} 
		return "";
	} else {
		if ('options' in info && info.options && Array.isArray(filterValue)) {
			// Check if the filterValue array is the same as the defaultValue array
			let filterValues= Object.values(filterValue).sort() as number[];
			const isEqual = filterValues.map(Number).length === (defaultValue as number[]).length && filterValues.map(Number).every(value => (defaultValue as number[]).includes(value));

			if (isEqual) {
				return ''; // If they are the same, return an empty string
			}

			// Otherwise, return the options as a comma-separated string
			const optionValues = filterValue .map((value) => info.options?.[value.toString() as keyof typeof info.options]) // Convert `value` to string .filter(Boolean); // Filter out any falsy values
			console.log(info);
			return info['label'] + ": "+optionValues.join(', '); // Return a comma-separated string
		} else if (filterValue && filterValue != defaultValue) {
			// Single value comparison (not an array)
			return info['label'] + ": "+info.options?.[filterValue as keyof typeof info.options] || filterValue;
		}

	}
	return ''; // If no match, return an empty string
};

